import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import {
  ADD_RATERS_TYPE,
  EDIT_RATERS_TYPE,
  LIST_RATERS_TYPE,
  VIEW_RATERS_TYPE,
  DELETE_RATERS_TYPE,
  // text
  ADD_RATERS_TYPE_TEXT,
  EDIT_RATERS_TYPE_TEXT,
  LIST_RATERS_TYPE_TEXT,
  VIEW_RATERS_TYPE_TEXT,
  DELETE_RATERS_TYPE_TEXT,
} from "./actionTypes"
import { ratersTypeSuccess, ratersTypeError } from "./actions"


import {
  onAddRatersType,
  onEditRatersType,
  onViewRatersType,
  onListRatersType,
  onDeleteRatersType,
  onAddRatersTypeText,
  onEditRatersTypeText,
  onListRatersTypeText,
  onViewRatersTypeText,
  onDeleteRatersTypeText
} from "helpers/backend_api_helper";

// add RaterType question
function* addRatersType({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddRatersType, data);
    yield put(ratersTypeSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// edit RaterType question
function* editRatersType({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditRatersType, data, id);
    yield put(ratersTypeSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// list RaterType question
function* listRatersType({ payload: { data, callback } }) {
  try {
    const response = yield call(onListRatersType, data);
    yield put(ratersTypeSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// view RaterType question
function* viewRatersType({ payload: { data, history } }) {
  try {
    const response = yield call(onViewRatersType, data);
    yield put(ratersTypeSuccess(response));

  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// delete RaterType question
function* deleteRatersType({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteRatersType, data);
    yield put(ratersTypeSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add RaterType question
function* addRatersTypeText({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddRatersTypeText, data);
    yield put(ratersTypeSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// edit RaterType question
function* editRatersTypeText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditRatersTypeText, data, id);
    yield put(ratersTypeSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// list RaterType question
function* listRatersTypeText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListRatersTypeText, data, id);
    yield put(ratersTypeSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// view RaterType question
function* viewRatersTypeText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewRatersTypeText, data);
    yield put(ratersTypeSuccess(response));

  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}

// delete RaterType question
function* deleteRatersTypeText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteRatersTypeText, data);
    yield put(ratersTypeSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(ratersTypeError(error?.response?.data?.message || "Server Error"));
  }
}



function* configRatersTypeSaga() {
  yield takeEvery(ADD_RATERS_TYPE, addRatersType);
  yield takeEvery(EDIT_RATERS_TYPE, editRatersType);
  yield takeEvery(LIST_RATERS_TYPE, listRatersType);
  yield takeEvery(VIEW_RATERS_TYPE, viewRatersType);
  yield takeEvery(DELETE_RATERS_TYPE, deleteRatersType);

  // text
  yield takeEvery(ADD_RATERS_TYPE_TEXT, addRatersTypeText);
  yield takeEvery(EDIT_RATERS_TYPE_TEXT, editRatersTypeText);
  yield takeEvery(LIST_RATERS_TYPE_TEXT, listRatersTypeText);
  yield takeEvery(VIEW_RATERS_TYPE_TEXT, viewRatersTypeText);
  yield takeEvery(DELETE_RATERS_TYPE_TEXT, deleteRatersTypeText);
}

export default configRatersTypeSaga;

